import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDisplayType } from '@fi-shared/types/display-type';

@Component({
    selector: 'fi-system-notifications-request-access',
    template: `
        <fi-user-requests-list [isMenuActionsShown]="false" [currentListDisplayType]="FiDisplayType.List">
        </fi-user-requests-list>
    `,
    styleUrls: ['./request-access.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-system-notifications-request-access' },
    standalone: false,
})
export class SystemNotificationsRequestAccessComponent {
    protected readonly FiDisplayType = FiDisplayType;
}
